import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './App';
import { TransactionProvider } from './context/TransactionsContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <TransactionProvider>
        <React.StrictMode>
            <App />
        </React.StrictMode>
    </TransactionProvider>
);
